import { render, staticRenderFns } from "./PayOrderQrPopup.vue?vue&type=template&id=72da52b3&scoped=true&"
import script from "./PayOrderQrPopup.vue?vue&type=script&lang=js&"
export * from "./PayOrderQrPopup.vue?vue&type=script&lang=js&"
import style0 from "./PayOrderQrPopup.vue?vue&type=style&index=0&id=72da52b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72da52b3",
  null
  
)

export default component.exports